"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonCms = void 0;
var CommonCms = /** @class */ (function () {
    function CommonCms() {
        this.btnLabelChange = 'Change';
        this.c2sNoStoresFoundRadius = "Hmm\u2026 None of the stores nearby have what you\u2019re looking for.\n Please try another location or expand your search area.";
        this.c2sNotAvailable = 'Not available for pickup near ZIP_CODE';
        this.c2sNotAvailableBE = "Oops! Something went wrong\n , and we can\u2019t provide a list of stores in your area. Please try again in a few minutes.";
        this.c2sOverlayNoStoresNearby = "Hmm\u2026 There aren\u2019t any stores within 50 miles of your location.\n If you\u2019d like to keep looking, consider trying a different ZIP Code.";
        this.c2sItemInCartNotAvailable = 'Hmm… There aren\'t any stores within XX miles of your location.' +
            'If you\'d like to keep looking, consider trying a different ZIP Code.';
        this.checkAvailability = 'Check availability';
        this.findStores = 'Find near by stores based on zip code';
        this.geolocationError = 'Hmm… We can’t find your location. Please try again or search by ZIP Code.';
        this.headerMsgPickItUpToday = 'Pick it up today';
        this.headerMsgPickItUpTomorrow = 'Pick it up tomorrow';
        this.headerMsgPickupinstore = 'Curbside or in-store pickup';
        this.headerAALMsgPickupinstore = 'In-store pickup';
        this.onlineOnly = 'Online only';
        this.pickUpStore = 'Select store to pickup the order';
        this.zipCodeInputError = 'Enter a valid ZIP Code';
        this.storeModelLegal = '/content/sharedcontent/en/legal/ipd-platform/sales/buy/wireless/storedisclaimer/_jcr_content/desktoplegal/legalsharedcontent';
        this.pickItUpNearYou = 'Pick it up near you';
        this.showStoresWithIn = 'Show stores within';
        this.searchByZipCode = 'Search by ZIP Code';
        this.fieldIsRequired = 'This field is required';
        this.useMyCurrentLocation = 'Use my current location';
        this.changeLocation = 'Change location';
        this.seeStores = 'See stores';
        this.todaysHours = 'Today\'s hours';
        this.noStoresInSelectedRadius = 'No stores in selected radius. Try again.';
        this.address = 'ADDRESS';
        this.pickUpAtThisStore = 'Pick up at this store';
        this.seeAllStoreHours = 'See all store hours';
        this.hideStoreHours = 'Hide store hours';
        this.storeHours = 'STORE HOURS';
        this.callTheStoreFor = 'Call the store for';
        this.holidayHours = 'holiday hours';
        this.storeAvailabilityTxt = 'Store Availability';
        this.checkoutModalTitle = 'Stores with your items in stock';
        this.curbsidePickup = 'Curbside pickup available';
        this.inStorePickup = 'Available within 2 hours. Curbside pickup is not available at this store.';
        this.disclaimerLabelTxt = 'This list doesn\'t include AT&T authorized retailers';
        this.showBingMaps = 'true';
    }
    return CommonCms;
}());
exports.CommonCms = CommonCms;
//# sourceMappingURL=Common.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/cms/Common.cms.js
// module id = 821
// module chunks = 8